import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import Product from 'src/app/model/product/product';
import { ProductTypes } from 'src/app/model/product/product-type';
import {
  ProductAssetsChangedEvent,
  ProjectDisplayObservableService,
} from 'src/app/services/project-display-observable.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { FilePickerComponent } from '../file-picker/file-picker.component';

@Component({
  selector: 'load-list',
  templateUrl: './load-list.component.html',
  styleUrls: ['./load-list.component.scss'],
})
export class LoadListComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @Input()
  product: Product;

  @Output()
  update = new EventEmitter<any>();

  @ViewChild(FilePickerComponent, { static: true })
  filePicker: FilePickerComponent;

  productTypes = ProductTypes;

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {
    super();
  }

  ngOnInit(): void {
    this.addSubscription(
      this.projectDisplayObservableService.getProductAssetsChangedSubscribable(),
      (event: ProductAssetsChangedEvent) => {
        if (
          event.productId === this.product.id &&
          event.formSection === 'sketchUp'
        ) {
          this.recalculateAssets();
        }
      }
    );
  }

  recalculateAssets(): void {
    this.filePicker.recalculateProductAssets();
  }
}
